import { render, staticRenderFns } from "./one-inquiry.vue?vue&type=template&id=1b52d9c6&scoped=true&"
import script from "./one-inquiry.vue?vue&type=script&lang=js&"
export * from "./one-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./one-inquiry.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./one-inquiry.vue?vue&type=style&index=1&id=1b52d9c6&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1b52d9c6",
  null
  
)

export default component.exports